import { render, staticRenderFns } from "./DxMachinery.vue?vue&type=template&id=4944a525&scoped=true&"
import script from "./DxMachinery.vue?vue&type=script&lang=js&"
export * from "./DxMachinery.vue?vue&type=script&lang=js&"
import style0 from "./DxMachinery.vue?vue&type=style&index=0&id=4944a525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4944a525",
  null
  
)

export default component.exports